<script>
    let cls = "sui-grid-item";
    export let span = 1;
</script>

<div class={cls} style:--span={span}>
    <slot />
</div>

<style lang="less">
    @import "./grid.less";
</style>
